import { Col, Input, Label, Row } from 'reactstrap';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../helpers/datePickerConfig';

const disableFutureDates = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

const SeccionIdentidad = ({ formik, document, menorEdad, userOU, handleFechaNacimiento }) => (
  <Row>
    <Col md="1">
      <Label htmlFor="id">
        <small>ID</small>
      </Label>
      <Input id="id" name="id" type="text" value={formik.values.id} disabled />
    </Col>
    <Col md="2">
      <Label htmlFor="nombre">
        <small>
          Nombre <span className="text-danger">*</span>
        </small>
      </Label>
      <Input
        id="nombre"
        name="nombre"
        type="text"
        disabled={userOU.centro === 'ORIENTACIÓN'}
        onChange={formik.handleChange}
        value={formik.values.nombre}
        className={formik.errors.nombre ? 'border border-danger error' : ''}
      />
      {formik.errors.nombre ? <div className="text-danger tiny">{formik.errors.nombre}</div> : null}
    </Col>
    <Col md="3">
      <Label htmlFor="apellidos">
        <small>
          Apellidos <span className="text-danger">*</span>
        </small>
      </Label>
      <Input
        id="apellidos"
        name="apellidos"
        type="text"
        onChange={formik.handleChange}
        value={formik.values.apellidos}
        className={formik.errors.apellidos ? 'border border-danger error' : ''}
        disabled={userOU.centro === 'ORIENTACIÓN'}
      />
      {formik.errors.apellidos ? (
        <div className="text-danger tiny">{formik.errors.apellidos}</div>
      ) : null}
    </Col>
    <Col md="2">
      <Label htmlFor="tipoDocumento">
        <small>
          Tipo de documento <span className="text-danger">*</span>
        </small>
      </Label>
      <Input
        id="tipoDocumento"
        name="tipoDocumento"
        type="select"
        disabled={userOU.centro === 'ORIENTACIÓN'}
        onChange={(e) => {
          const value = e.target.value.replace(/\s+/g, '');
          formik.setFieldValue('tipoDocumento', value);
        }}
        value={formik.values.tipoDocumento}
        className={formik.errors.tipoDocumento ? 'border border-danger error' : ''}
      >
        {document !== ''
          ? document.map((option) => (
              <option key={`${option.id}-documento`} value={option.id}>
                {option.nombre}
              </option>
            ))
          : ''}
      </Input>
      {formik.errors.tipoDocumento ? (
        <div className="text-danger tiny">{formik.errors.tipoDocumento}</div>
      ) : null}
    </Col>
    <Col md="2">
      <Label htmlFor="documento">
        <small>
          Documento <span className="text-danger">*</span>
        </small>
      </Label>
      <Input
        id="documento"
        name="documento"
        type="text"
        onChange={formik.handleChange}
        value={formik.values.documento}
        className={formik.errors.documento ? 'border border-danger error' : ''}
        disabled={formik.values.tipoDocumento === '-1' || userOU.centro === 'ORIENTACIÓN'}
      />
      {formik.errors.documento ? (
        <div className="text-danger tiny">{formik.errors.documento}</div>
      ) : null}
    </Col>
    <Col md="2">
      <Label htmlFor="fechaNacimiento">
        <small>
          Fecha nacimiento <span className="text-danger">*</span>
        </small>
      </Label>
      <DatePicker
        selected={formik.values.fechaNacimiento}
        onChange={handleFechaNacimiento}
        dateFormat="dd/MM/yyyy"
        locale="es"
        maxDate={new Date()}
        filterDate={disableFutureDates}
        disabled={userOU.centro === 'ORIENTACIÓN'}
        className={`form-control ${
          formik.errors.fechaNacimiento ? 'border border-danger error rounded' : ''
        }`}
        wrapperClassName="w-100"
      />
      {menorEdad && (
        <span className="text-warning">
          <b>Es alumno menor</b>
        </span>
      )}
      {formik.errors.fechaNacimiento ? (
        <div className="text-danger tiny">{formik.errors.fechaNacimiento}</div>
      ) : null}
    </Col>
  </Row>
);

SeccionIdentidad.propTypes = {
  formik: PropTypes.object.isRequired,
  document: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  menorEdad: PropTypes.bool,
  userOU: PropTypes.object.isRequired,
  handleFechaNacimiento: PropTypes.func.isRequired,
};

export default SeccionIdentidad;
